import { useApi } from '../services';

export const useSendQuoteEditEmbed = (idOperation) => useApi(`v2/operation/${idOperation}/quote/send-quote-edit-embed`, 'POST', {}, {});

export const useSaveSelectMarkets = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets`, 'POST', {}, {});

export const useGetSelectedMarkets = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets`, 'GET', {}, {});

export const usePostSelectedMarketsSend = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets/send`, 'POST', {}, {});

export const useUpdateSelectedMarketsStatus = (idOperation) => useApi(`v2/operation/${idOperation}/quote/select-markets/status`, 'PUT', {}, {});

export const useGenerateQuote = (idOperation) => useApi(`v2/operation/${idOperation}/quote/generate-quote`, 'POST', {}, {});

export const useSendQuote = (idOperation) => useApi(`v2/operation/${idOperation}/quote/send`, 'POST', {}, {});

export const useGetPremiumCalculation = (idOperation) => useApi(`v2/operation/${idOperation}/premium-calculation`, 'POST', {}, {});

export const useSavePremiumCalculation = (idOperation) => useApi(`v2/operation/${idOperation}/premium-calculation`, 'PUT', {}, {});

export const useGenerateBindCover = (idOperation) => useApi(`v2/operation/${idOperation}/order-to-bind/bind-cover`, 'POST', {}, {});

export const useGenerateOrderToBind = (idOperation) => useApi(`v2/operation/${idOperation}/order-to-bind`, 'POST', {}, {});

export const useGenerateOrderToBindSend = (idOperation) => useApi(`v2/operation/${idOperation}/order-to-bind/send`, 'POST', {}, {});

export const useGetQuoteExport = () => useApi(`/report/quotes-meridian/xlsx`, 'GET', {}, {});

export const useGenerateQuoteASync = (idOperation) => useApi(`v2/operation/${idOperation}/quote/generate-quote`, 'POST', {}, {}, true);

export const useCreateQuotationOptionAsync = () => useApi(`/nbi/v2/create-option`, 'POST', {}, {}, true);

export const useGetQuotePlansAsync = (idOperation) => useApi(`/nbi/v2/create-option/${idOperation}`, 'GET', {}, {}, true);

export const useDeleteQuotePlanAsync = (idOperation) => useApi(`/nbi/v2/remove-option/${idOperation}`, 'DELETE', {}, {}, true);

export const useSaveExtraModalityAsync = (idOperation) => useApi(`/nbi/v2/create-sub-option/${idOperation}`, 'POST', {}, {}, true);

export const useCreateQuoteOperation = () => useApi(`v2/operation/quote`, 'POST', {}, {});

export const useUpdateQuoteOperation = (idOperation) => useApi(`v2/operation/quote/${idOperation}`, 'PUT', {}, {});